<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <div>
      <h3 class="h3">{{ 'subscriptionRules.subscriptionManagement' | transloco }}</h3>
      <div class="text-muted">
        {{ 'subscriptionRules.subscriptionManagementHelp' | transloco }}
      </div>

      <!-- Skeleton Loader -->
      @if (!subscriptionRulesDataLoaded) {
        <div class="skeleton-loader">
          <div class="card shadow mt-2">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="skeleton" style="width: 350px; height: 24px;"></div>
                <div class="skeleton" style="width: 160px; height: 36px; border-radius: 6px;"></div>
              </div>
              <div class="skeleton" style="width: 80%; height: 14px; margin-bottom: 20px;"></div>
              <div class="d-flex justify-content-around mt-3 w-100" style="gap: 16px;">
                <div style="width: 50%; border: 1px solid #e9ecef; border-radius: 8px; padding: 16px;">
                  <div class="skeleton mx-auto" style="width: 200px; height: 40px; margin-bottom: 16px;"></div>
                  <div class="skeleton" style="width: 100%; height: 18px; margin-bottom: 12px;"></div>
                  <div class="skeleton" style="width: 90%; height: 14px; margin-bottom: 12px;"></div>
                  <div class="skeleton" style="width: 100%; height: 18px; margin-bottom: 12px;"></div>
                  <div class="skeleton" style="width: 85%; height: 14px; margin-bottom: 12px;"></div>
                  <div class="skeleton" style="width: 100%; height: 18px; margin-bottom: 12px;"></div>
                  <div class="skeleton" style="width: 80%; height: 14px;"></div>
                </div>
                <div style="width: 50%; border: 1px solid #e9ecef; border-radius: 8px; padding: 16px;">
                  <div class="skeleton mx-auto" style="width: 200px; height: 40px; margin-bottom: 16px;"></div>
                  <div class="skeleton" style="width: 100%; height: 18px; margin-bottom: 12px;"></div>
                  <div class="skeleton" style="width: 90%; height: 14px; margin-bottom: 12px;"></div>
                  <div class="skeleton" style="width: 100%; height: 18px; margin-bottom: 12px;"></div>
                  <div class="skeleton" style="width: 85%; height: 14px; margin-bottom: 12px;"></div>
                  <div class="skeleton" style="width: 100%; height: 18px; margin-bottom: 12px;"></div>
                  <div class="skeleton" style="width: 80%; height: 14px;"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="border p-3 my-5">
            <div class="skeleton" style="width: 280px; height: 24px; margin-bottom: 12px;"></div>
            <div class="skeleton" style="width: 80%; height: 14px; margin-bottom: 16px;"></div>
            @for (i of [1,2,3]; track i) {
              <div class="d-flex py-3" style="border-bottom: 1px solid #f1f5f9; gap: 16px;">
                <div class="skeleton" style="width: 15%; height: 16px;"></div>
                <div class="skeleton" style="width: 10%; height: 16px;"></div>
                <div class="skeleton" style="width: 10%; height: 16px;"></div>
                <div class="skeleton" style="width: 10%; height: 16px;"></div>
                <div class="skeleton" style="width: 10%; height: 16px;"></div>
                <div class="skeleton" style="width: 10%; height: 16px;"></div>
                <div class="skeleton" style="width: 10%; height: 16px;"></div>
                <div class="skeleton" style="width: 10%; height: 16px;"></div>
                <div class="skeleton" style="width: 15%; height: 16px;"></div>
              </div>
            }
          </div>
        </div>
      }

      @if (subscriptionRulesDataLoaded && activeSubscriptionRule) {
        <div class="card shadow mt-2">
          <div class="card-body p-3">
            <div class="row">
              <!-- Active Subscription Rule Details -->
              @if (activeSubscriptionRule) {
                <div class="d-flex flex-column">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="fs-4 fw-semibold">
                      {{ 'subscriptionRules.currentlyActiveRuleSet' | transloco: { ruleName: activeSubscriptionRule.RuleName } }}
                    </div>
                    <div>
                      <button type="button" pButton class="p-button-primary p-button-outlined p-button-sm"
                        (click)="onEditSubscription(activeSubscriptionRule)" [label]="'subscriptionRules.editActiveRuleset' | transloco"
                      icon="fa fa-pencil"></button>
                    </div>
                  </div>
                  <p class="text-muted">
                    <i class="fa fa-info-circle me-1"></i> {{ 'subscriptionRules.limitsAppliedWhenJoin' | transloco }}
                  </p>
                </div>
                <!-- Subscription Rule Details for Artist and Gallery -->
                <div class="d-flex justify-content-around mt-3 w-100">
                  <!-- Artist Subscription Features -->
                  <div class="border p-3 w-50">
                    <div class="d-flex justify-content-center">
                      <img src="assets/images/AFP-logo-horizontal/AFP-logo-free-artists-300.png" width="200" />
                    </div>
                    <div class="mt-3 px-3">
                      <div class="border rounded mb-2">
                        <div class="fw-bold border-bottom p-2">
                          {{ 'subscriptionRules.featureLimitsArtist' | transloco }}
                        </div>
                        <div class="p-2">
                          <div class="d-flex flex-column mb-2">
                            <span class="fw-semibold text-uppercase">{{ 'subscriptionRules.numberOfArtistProductsLabel' | transloco }}
                            {{activeSubscriptionRule.NumberOfArtistProducts}}</span>
                            <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'subscriptionRules.numberOfArtistProductsHelp' | transloco }}</p>
                        </div>
                        <div class="d-flex flex-column mb-2">
                          <span class="fw-semibold text-uppercase">{{ 'subscriptionRules.numberOfConnectionsAllowedLabel' | transloco }}
                          {{activeSubscriptionRule.NumberOfConnectionsAllowedToArtists}}</span>
                          <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'subscriptionRules.artistConnectionsHelp' | transloco }}</p>
                      </div>
                      <div class="d-flex flex-column mb-2">
                        <span class="fw-semibold text-uppercase">{{ 'subscriptionRules.numberOfAllowedArtTypesLabel' | transloco }}
                        {{activeSubscriptionRule.NumberOfArtTypeSelection}}</span>
                        <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'subscriptionRules.numberOfAllowedArtTypesHelp' | transloco }}</p>
                    </div>
                    <div class="d-flex flex-column mb-2">
                      <span class="fw-semibold text-uppercase">{{ 'subscriptionRules.numberOfAllowedAiDescriptionsLabel' | transloco }}
                      {{activeSubscriptionRule.NumberOfArtistAIDescriptionCalls}}</span>
                      <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'subscriptionRules.artistAiDescriptionsHelp' | transloco }}</p>
                  </div>
                  <div class="d-flex flex-column mb-2">
                    <span class="fw-semibold text-uppercase">{{ 'subscriptionRules.numberOfAllowedPortfoliosLabel' | transloco }}
                    {{activeSubscriptionRule.NumberOfArtistPortfolios}}</span>
                    <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'subscriptionRules.artistPortfoliosHelp' | transloco }}</p>
                </div>
              </div>
            </div>
            <div class="border rounded">
              <div class="fw-bold border-bottom p-2">
                {{ 'subscriptionRules.featureVisibilityArtist' | transloco }}
              </div>
              @for (feature of activeSubscriptionRule.appFeaturePermissionDto; track feature) {
                <div>
                  @if (feature.FeatureFor === 'Artist') {
                    <div class="ps-2 py-2">
                      <input type="checkbox" [(ngModel)]="feature.IsEnabled" [ngModelOptions]="{standalone: true}"
                        [disabled]="true" />
                        <label [for]="feature.Id" class="ps-2 fw-bold">{{ feature.FeatureLabel }}</label>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <!-- Gallery Subscription Features -->
          <div class="border p-3 w-50">
            <div class="d-flex justify-content-center">
              <img src="assets/images/AFP-logo-horizontal/AFP-logo-free-galleries-300.png" width="200" />
            </div>
            <div class="mt-3 px-3">
              <div class="border rounded mb-2">
                <div class="fw-bold border-bottom p-2">
                  {{ 'subscriptionRules.featureLimitsGallery' | transloco }}
                </div>
                <div class="p-2">
                  <div class="d-flex flex-column mb-2">
                    <span class="fw-semibold text-uppercase">{{ 'subscriptionRules.numberOfConsignmentProductsLabel' | transloco }}
                    {{activeSubscriptionRule.NumberOfConsignmentProductAccepted}}</span>
                    <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'subscriptionRules.consignmentProductsHelp' | transloco }}</p>
                </div>
                <div class="d-flex flex-column mb-2">
                  <span class="fw-semibold text-uppercase">{{ 'subscriptionRules.numberOfConnectionsAllowedLabel' | transloco }}
                  {{activeSubscriptionRule.NumberOfConnectionsAllowedToGallery}}</span>
                  <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'subscriptionRules.galleryConnectionsHelp' | transloco }}</p>
              </div>
              <div class="d-flex flex-column mb-2">
                <span class="fw-semibold text-uppercase">{{ 'subscriptionRules.numberOfGalleryProductsLabel' | transloco }}
                {{activeSubscriptionRule.NumberOfGalleryProducts}}</span>
                <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'subscriptionRules.galleryProductsHelp' | transloco }}</p>
            </div>
            <div class="d-flex flex-column mb-2">
              <span class="fw-semibold text-uppercase">{{ 'subscriptionRules.numberOfAllowedAiDescriptionsLabel' | transloco }}
              {{activeSubscriptionRule.NumberOfGalleryAIDescriptionCalls}}</span>
              <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'subscriptionRules.galleryAiDescriptionsHelp' | transloco }}</p>
          </div>
          <div class="d-flex flex-column mb-2">
            <span class="fw-semibold text-uppercase">{{ 'subscriptionRules.numberOfAllowedPortfoliosLabel' | transloco }}
            {{activeSubscriptionRule.NumberOfGalleryPortfolios}}</span>
            <p class="text-muted"><i class="fa fa-info-circle me-1"></i>{{ 'subscriptionRules.galleryPortfoliosHelp' | transloco }}</p>
        </div>
      </div>
    </div>
    <div class="border rounded">
      <div class="fw-bold border-bottom p-2">
        {{ 'subscriptionRules.featureVisibilityGallery' | transloco }}
      </div>
      @for (feature of activeSubscriptionRule.appFeaturePermissionDto; track feature) {
        <div>
          @if (feature.FeatureFor === 'Gallery') {
            <div class="ps-2 py-2">
              <input type="checkbox" [(ngModel)]="feature.IsEnabled" [ngModelOptions]="{standalone: true}"
                [disabled]="true" />
                <label [for]="feature.Id" class="ps-2 fw-bold">{{ feature.FeatureLabel }}</label>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="mt-2">
  <div class="d-flex flex-column">
    <span class="fw-semibold">{{ 'subscriptionRules.updatedLabel' | transloco }} {{activeSubscriptionRule.CreatedAt | date: 'dd/MM/yyyy
    HH:mm'}}</span>
  </div>
</div>
}
</div>
</div>
</div>
}

<!-- Subscription Rulesets History -->
<div class="table-responsive my-5 border p-3">
  <h4 class="h4">{{ 'subscriptionRules.subscriptionRulesetsHistory' | transloco }}</h4>
  <div class="mb-2">
    {{ 'subscriptionRules.rulesetsHistoryHelp' | transloco }}
  </div>
  <p-table #dt [value]="subscriptionRules" dataKey="Id" [rowHover]="true"
    styleClass="p-datatable-gridlines p-datatable-striped" [globalFilterFields]="['RuleName']"
    [paginator]="subscriptionRules.length > 10" [rows]="10" [reorderableColumns]="true" [resizableColumns]="false"
    selectionMode="single">
    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
      <tr>
        <td style="min-width: 200px;">
          <div class="d-flex align-items-center">
            <div class="text-uppercase">{{rowData.RuleName}}
              @if (rowData.IsActive) {
                <i class="pi pi-verified text-success ms-2" title="{{rowData.IsActive}}"
                ></i>
              }
              @if (!rowData.IsActive) {
                <i class="pi pi-times-circle text-danger ms-2" title="{{!rowData.IsActive}}"
                ></i>
              }
            </div>
          </div>
          <div class="text-muted small">{{ 'subscriptionRules.createdLabel' | transloco }} {{rowData.CreatedAt | date: 'dd/MM/yyyy HH:mm'}}</div>
        </td>
        <td>
          <div class="fs-5">{{rowData.NumberOfArtistProducts}}</div>
          <div class="small">{{ 'subscriptionRules.colArtistProducts' | transloco }}</div>
        </td>
        <td>
          <div class="fs-5">{{rowData.NumberOfConnectionsAllowedToArtists}}</div>
          <div class="small">{{ 'subscriptionRules.colArtistConnections' | transloco }}</div>
        </td>
        <td>
          <div class="fs-5">{{rowData.NumberOfConnectionsAllowedToGallery}}</div>
          <div class="small">{{ 'subscriptionRules.colGalleryConnections' | transloco }}</div>
        </td>
        <td>
          <div class="fs-5">{{rowData.NumberOfConsignmentProductAccepted}}</div>
          <div class="small">{{ 'subscriptionRules.colConsignmentProducts' | transloco }}</div>
        </td>
        <td>
          <div class="fs-5">{{rowData.NumberOfArtTypeSelection}}</div>
          <div class="small">{{ 'subscriptionRules.colArtTypes' | transloco }}</div>
        </td>
        <td>
          <div class="fs-5">{{rowData.NumberOfArtistAIDescriptionCalls}}</div>
          <div class="small">{{ 'subscriptionRules.colArtistAiDescriptions' | transloco }}</div>
        </td>
        <td>
          <div class="fs-5">{{rowData.NumberOfArtistPortfolios}}</div>
          <div class="small">{{ 'subscriptionRules.colArtistPortfolios' | transloco }}</div>
        </td>
        <td>
          <div class="fs-5">{{rowData.NumberOfGalleryPortfolios}}</div>
          <div class="small">{{ 'subscriptionRules.colGalleryPortfolios' | transloco }}</div>
        </td>
        <td class="d-flex justify-content-between mt-5">
          @if (!rowData.IsActive) {
            <button type="button" pButton class="p-button p-button-outlined" icon="fa fa-refresh" [label]="'subscriptionRules.switch' | transloco"
            (click)="onSwitchSubscription(rowData)"></button>
          }
          <button type="button" pButton class="p-button p-button-outlined"
            [ngClass]="{'ms-2': !rowData.IsActive, 'mx-5': rowData.IsActive}" icon="fa fa-eye" [label]="'subscriptionRules.view' | transloco"
          (click)="getRulesetUsers(rowData.Id)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="8">
          <div class="text-center">{{ 'subscriptionRules.noRulesetsFound' | transloco }}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
</div>
</div>
</div>




<p-dialog [header]="'subscriptionRules.editActiveSubscriptionRules' | transloco" [(visible)]="subscriptionRuleDialogVisible" [modal]="true"
  [style]="{ width: '900px' }" (onHide)="closeDialog()">
  @if (subscriptionRule) {
    <form class="container">
      <div class="row g-3">
        <div class="col-12">
          <div class="mb-3">
            <label for="ruleName" class="form-label">{{ 'subscriptionRules.rulesetName' | transloco }}</label>
            <input type="text" class="form-control" [placeholder]="'subscriptionRules.enterRuleNamePlaceholder' | transloco" [(ngModel)]="subscriptionRule.RuleName"
              (blur)="updateRuleName()" name="ruleName" id="ruleName" required />
              <small class="form-text text-muted">{{ 'subscriptionRules.rulesetNameHelp' | transloco }}</small>
            </div>
          </div>
          <p-tabView [(activeIndex)]="selectedTabIndex">
            <p-tabPanel [header]="'subscriptionRules.forArtists' | transloco">
              <div class="border shadow-lg p-4 rounded bg-white">
                <div class="row">
                  <div class="col-md-6">
                    <div class="border shadow-sm rounded bg-white">
                      <div class="border-bottom p-2 fw-bold">
                        {{ 'subscriptionRules.featureLimits' | transloco }}
                      </div>
                      <div class="p-2">
                        <div class="mt-3 mb-3">
                          <label for="numberOfArtistProducts" class="form-label">{{ 'subscriptionRules.formNumberOfArtistProducts' | transloco }}</label>
                          <input type="number" class="form-control"
                            [placeholder]="'subscriptionRules.formNumberOfArtistProductsPlaceholder' | transloco"
                            [(ngModel)]="subscriptionRule.NumberOfArtistProducts" name="numberOfArtistProducts" min="0"
                            id="numberOfArtistProducts" (input)="preventNegativeValues($event,'NumberOfArtistProducts')"
                            required />
                            <div class="text-muted small">{{ 'subscriptionRules.formNumberOfArtistProductsHelp' | transloco }}</div>
                          </div>
                          <div class="mb-3">
                            <label for="numberOfConnectionsAllowedToArtists" class="form-label">{{ 'subscriptionRules.formConnectionsToArtists' | transloco }}</label>
                            <input type="number" class="form-control" [placeholder]="'subscriptionRules.formConnectionsToArtistsPlaceholder' | transloco"
                              [(ngModel)]="subscriptionRule.NumberOfConnectionsAllowedToArtists" min="0"
                              name="numberOfConnectionsAllowedToArtists" id="numberOfConnectionsAllowedToArtists"
                              (input)="preventNegativeValues($event,'NumberOfConnectionsAllowedToArtists')" required />
                              <div class="text-muted small">{{ 'subscriptionRules.formConnectionsToArtistsHelp' | transloco }}</div>
                            </div>
                            <div class="mb-3">
                              <label for="numberOfArtTypeSelection" class="form-label">{{ 'subscriptionRules.formArtTypeSelections' | transloco }}</label>
                              <input type="number" class="form-control" [placeholder]="'subscriptionRules.formArtTypeSelectionsPlaceholder' | transloco"
                                [(ngModel)]="subscriptionRule.NumberOfArtTypeSelection" name="numberOfArtTypeSelection" min="0"
                                id="numberOfArtTypeSelection" (input)="preventNegativeValues($event,'NumberOfArtTypeSelection')"
                                required />
                                <div class="text-muted small">{{ 'subscriptionRules.formArtTypeSelectionsHelp' | transloco }}</div>
                              </div>
                              <div class="mb-3">
                                <label for="numberOfArtistAIDescriptionCalls" class="form-label">{{ 'subscriptionRules.formAiDescriptionCalls' | transloco }}</label>
                                <input type="number" class="form-control"
                                  [placeholder]="'subscriptionRules.formAiDescriptionCallsPlaceholder' | transloco"
                                  [(ngModel)]="subscriptionRule.NumberOfArtistAIDescriptionCalls"
                                  name="numberOfArtistAIDescriptionCalls" min="0" id="numberOfArtistAIDescriptionCalls"
                                  (input)="preventNegativeValues($event,'NumberOfArtistAIDescriptionCalls')" required />
                                  <div class="text-muted small">{{ 'subscriptionRules.formArtistAiDescriptionCallsHelp' | transloco }}</div>
                                </div>
                                <div class="mb-3">
                                  <label for="numberOfArtistPortfolios" class="form-label">{{ 'subscriptionRules.formAllowedPortfolios' | transloco }}</label>
                                  <input type="number" class="form-control"
                                    [placeholder]="'subscriptionRules.formArtistPortfoliosPlaceholder' | transloco"
                                    [(ngModel)]="subscriptionRule.NumberOfArtistPortfolios" name="numberOfArtistPortfolios" min="0"
                                    id="numberOfArtistPortfolios" (input)="preventNegativeValues($event,'NumberOfArtistPortfolios')"
                                    required />
                                    <div class="text-muted small">{{ 'subscriptionRules.formArtistPortfoliosHelp' | transloco }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="border shadow-sm rounded bg-white">
                                <div class="border-bottom p-2 fw-bold">
                                  {{ 'subscriptionRules.featureVisibility' | transloco }}
                                </div>
                                <div class="p-2">
                                  @for (feature of subscriptionRule.appFeaturePermissionDto; track feature) {
                                    <div class="mb-2">
                                      @if (feature.FeatureFor === 'Artist') {
                                        <input type="checkbox" [id]="feature.Id"
                                          [(ngModel)]="feature.IsEnabled" [ngModelOptions]="{standalone: true}"
                                          (change)="toggleFeature(feature)" />
                                      }
                                      @if (feature.FeatureFor === 'Artist') {
                                        <label class="ps-2 fw-bold">{{ feature.FeatureLabel
                                        }}</label>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </p-tabPanel>
                      <p-tabPanel [header]="'subscriptionRules.forGalleries' | transloco">
                        <div class="border shadow-lg p-4 rounded bg-white">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="border shadow-sm rounded bg-white">
                                <div class="border-bottom p-2 fw-bold">{{ 'subscriptionRules.featureLimits' | transloco }}</div>
                                <div class="p-2">
                                  <div class="mt-3 mb-3">
                                    <label for="numberOfGalleryProducts" class="form-label">{{ 'subscriptionRules.formNumberOfGalleryProducts' | transloco }}</label>
                                    <input type="number" class="form-control"
                                      [placeholder]="'subscriptionRules.formNumberOfGalleryProductsPlaceholder' | transloco"
                                      [(ngModel)]="subscriptionRule.NumberOfGalleryProducts" name="numberOfGalleryProducts" min="0"
                                      id="numberOfGalleryProducts" (input)="preventNegativeValues($event,'NumberOfGalleryProducts')"
                                      required />
                                      <div class="text-muted small">{{ 'subscriptionRules.formNumberOfGalleryProductsHelp' | transloco }}</div>
                                    </div>
                                    <div class="mb-3">
                                      <label for="numberOfConnectionsAllowedToGallery" class="form-label">{{ 'subscriptionRules.formConnectionsToGallery' | transloco }}</label>
                                      <input type="number" class="form-control" [placeholder]="'subscriptionRules.formConnectionsToGalleryPlaceholder' | transloco"
                                        [(ngModel)]="subscriptionRule.NumberOfConnectionsAllowedToGallery" min="0"
                                        name="numberOfConnectionsAllowedToGallery" id="numberOfConnectionsAllowedToGallery"
                                        (input)="preventNegativeValues($event,'NumberOfConnectionsAllowedToGallery')" required />
                                        <div class="text-muted small">{{ 'subscriptionRules.formConnectionsToGalleryHelp' | transloco }}</div>
                                      </div>
                                      <div class="mb-3">
                                        <label for="NumberOfConsignmentProductAccepted" class="form-label">{{ 'subscriptionRules.formConsignmentProducts' | transloco }}</label>
                                        <input type="number" class="form-control" [placeholder]="'subscriptionRules.formConsignmentProductsPlaceholder' | transloco"
                                          [(ngModel)]="subscriptionRule.NumberOfConsignmentProductAccepted"
                                          name="NumberOfConsignmentProductAccepted" min="0" id="NumberOfConsignmentProductAccepted"
                                          (input)="preventNegativeValues($event,'NumberOfConsignmentProductAccepted')" required />
                                          <div class="text-muted small">{{ 'subscriptionRules.formConsignmentProductsHelp' | transloco }}</div>
                                        </div>
                                        <div class="mb-3">
                                          <label for="numberOfGalleryAIDescriptionCalls" class="form-label">{{ 'subscriptionRules.formAiDescriptionCalls' | transloco }}</label>
                                          <input type="number" class="form-control"
                                            [placeholder]="'subscriptionRules.formAiDescriptionCallsPlaceholder' | transloco"
                                            [(ngModel)]="subscriptionRule.NumberOfGalleryAIDescriptionCalls"
                                            name="numberOfGalleryAIDescriptionCalls" min="0" id="numberOfGalleryAIDescriptionCalls"
                                            (input)="preventNegativeValues($event,'NumberOfGalleryAIDescriptionCalls')" required />
                                            <div class="text-muted small">{{ 'subscriptionRules.formGalleryAiDescriptionCallsHelp' | transloco }}</div>
                                          </div>
                                          <div class="mb-3">
                                            <label for="numberOfGalleryPortfolios" class="form-label">{{ 'subscriptionRules.formAllowedPortfolios' | transloco }}</label>
                                            <input type="number" class="form-control"
                                              [placeholder]="'subscriptionRules.formGalleryPortfoliosPlaceholder' | transloco"
                                              [(ngModel)]="subscriptionRule.NumberOfGalleryPortfolios" name="numberOfGalleryPortfolios"
                                              min="0" id="numberOfGalleryPortfolios"
                                              (input)="preventNegativeValues($event,'NumberOfGalleryPortfolios')" required />
                                              <div class="text-muted small">{{ 'subscriptionRules.formGalleryPortfoliosHelp' | transloco }}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="border shadow-sm rounded bg-white">
                                          <div class="border-bottom p-2 fw-bold">{{ 'subscriptionRules.featureVisibility' | transloco }}</div>
                                          <div class="p-2">
                                            @for (feature of subscriptionRule.appFeaturePermissionDto; track feature) {
                                              <div class="mb-2">
                                                @if (feature.FeatureFor === 'Gallery') {
                                                  <input type="checkbox" [id]="feature.Id"
                                                    [(ngModel)]="feature.IsEnabled" [ngModelOptions]="{ standalone: true }"
                                                    (change)="toggleFeature(feature)" />
                                                }
                                                @if (feature.FeatureFor === 'Gallery') {
                                                  <label class="ps-2 fw-bold">{{ feature.FeatureLabel
                                                  }}</label>
                                                }
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </p-tabPanel>
                              </p-tabView>
                            </div>
                            <div class="d-grid mt-4">
                              <button pButton type="button" (click)="onSaveSubscriptionRule()" [label]="'subscriptionRules.saveGlobalSubscriptionRules' | transloco"
                              class="p-button-outlined p-button-lg p-button-primary"></button>
                            </div>
                          </form>
                        }
                      </p-dialog>

                      <p-dialog [header]="'subscriptionRules.ruleSetUsersHeader' | transloco: { ruleName: currentSubscriptionRule?.RuleName }"
                        [(visible)]="subscriptionRuleUsersDailogVisible" [modal]="true" [style]="{ width: '920px' }"
                        (onHide)="onCloseAllRuleSetUsersDialog()">

                        @if (currentSubscriptionRule) {
                          <div class="d-flex flex-column p-2">
                            <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="filterUsers()">
                              <!-- Galleries Tab Panel -->
                              <p-tabPanel [header]="'subscriptionRules.viewGalleries' | transloco">
                                <ng-container>
                                  <p-accordion>
                                    <p-accordionTab [header]="'subscriptionRules.planLimits' | transloco">
                                      <div class="p-3 mb-2 bg-light rounded border border-secondary shadow-sm">
                                        <div class="text-muted mb-2">
                                          <strong>{{ 'subscriptionRules.information' | transloco }}</strong> {{ 'subscriptionRules.galleriesTableInfo' | transloco }}
                                        </div>
                                        <div class="d-flex flex-column mt-4">
                                          <ul class="px-3">
                                            <li>
                                              <div class="d-flex flex-column justify-content-start">
                                                <div>
                                                  <span class="text-secondary fw-semibold text-uppercase">{{ 'subscriptionRules.galleryConnectionsItemLabel' | transloco }} </span>
                                                  <span
                                                  class="text-secondary ms-2">{{currentSubscriptionRule.NumberOfConnectionsAllowedToGallery}}</span>
                                                </div>
                                                <div class="text-small text-muted">{{ 'subscriptionRules.galleryConnectionsItemHelp' | transloco }}</div>
                                              </div>
                                            </li>
                                            <li>
                                              <div class="d-flex flex-column justify-content-start mt-2">
                                                <div>
                                                  <span class="text-secondary fw-semibold text-uppercase">{{ 'subscriptionRules.consignedProductsItemLabel' | transloco }} </span>
                                                  <span
                                                  class="text-secondary ms-2">{{currentSubscriptionRule.NumberOfConsignmentProductAccepted}}</span>
                                                </div>
                                                <div class="text-small text-muted">{{ 'subscriptionRules.consignedProductsItemHelp' | transloco }}</div>
                                              </div>
                                            </li>
                                            <!-- Additional List Items for Plan Limits -->
                                            <li>
                                              <div class="d-flex flex-column justify-content-start mt-2">
                                                <div>
                                                  <span class="text-secondary fw-semibold text-uppercase">{{ 'subscriptionRules.galleryProductsItemLabel' | transloco }} </span>
                                                  <span class="text-secondary ms-2">{{currentSubscriptionRule.NumberOfGalleryProducts}}</span>
                                                </div>
                                                <div class="text-small text-muted">{{ 'subscriptionRules.galleryProductsItemHelp' | transloco }}</div>
                                              </div>
                                            </li>
                                            <li>
                                              <div class="d-flex flex-column justify-content-start mt-2">
                                                <div>
                                                  <span class="text-secondary fw-semibold text-uppercase">{{ 'subscriptionRules.aiDescriptionCallsMonthItemLabel' | transloco }} </span>
                                                  <span
                                                  class="text-secondary ms-2">{{currentSubscriptionRule.NumberOfGalleryAIDescriptionCalls}}</span>
                                                </div>
                                                <div class="text-small text-muted">{{ 'subscriptionRules.galleryAiDescriptionCallsItemHelp' | transloco }}</div>
                                              </div>
                                            </li>
                                            <li>
                                              <div class="d-flex flex-column justify-content-start mt-2">
                                                <div>
                                                  <span class="text-secondary fw-semibold text-uppercase">{{ 'subscriptionRules.portfoliosCreationItemLabel' | transloco }} </span>
                                                  <span class="text-secondary ms-2">{{currentSubscriptionRule.NumberOfGalleryPortfolios}}</span>
                                                </div>
                                                <div class="text-small text-muted">{{ 'subscriptionRules.galleryPortfoliosItemHelp' | transloco }}</div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </p-accordionTab>
                                  </p-accordion>
                                </ng-container>
                              </p-tabPanel>
                              <!-- Artists Tab Panel -->
                              <p-tabPanel [header]="'subscriptionRules.viewArtists' | transloco">
                                @if (!showArtists) {
                                  <p-accordion>
                                    <p-accordionTab [header]="'subscriptionRules.planLimits' | transloco">
                                      <div class="p-3 mb-2 bg-light rounded border border-secondary shadow-sm">
                                        <div class="text-muted mb-2">
                                          <strong>{{ 'subscriptionRules.information' | transloco }}</strong> {{ 'subscriptionRules.artistsTableInfo' | transloco }}
                                        </div>
                                        <div class="d-flex flex-column mt-4">
                                          <ul class="px-3">
                                            <li>
                                              <div class="d-flex flex-column justify-content-start">
                                                <div>
                                                  <span class="text-secondary fw-semibold text-uppercase">{{ 'subscriptionRules.artistProductsItemLabel' | transloco }} </span>
                                                  <span class="text-secondary ms-2">{{currentSubscriptionRule.NumberOfArtistProducts}}</span>
                                                </div>
                                                <div class="text-small text-muted">{{ 'subscriptionRules.artistProductsItemHelp' | transloco }}</div>
                                              </div>
                                            </li>
                                            <li>
                                              <div class="d-flex flex-column justify-content-start mt-2">
                                                <div>
                                                  <span class="text-secondary fw-semibold text-uppercase">{{ 'subscriptionRules.artistConnectionsItemLabel' | transloco }} </span>
                                                  <span
                                                  class="text-secondary ms-2">{{currentSubscriptionRule.NumberOfConnectionsAllowedToArtists}}</span>
                                                </div>
                                                <div class="text-small text-muted">{{ 'subscriptionRules.artistConnectionsItemHelp' | transloco }}</div>
                                              </div>
                                            </li>
                                            <!-- Additional List Items for Plan Limits -->
                                            <li>
                                              <div class="d-flex flex-column justify-content-start mt-2">
                                                <div>
                                                  <span class="text-secondary fw-semibold text-uppercase">{{ 'subscriptionRules.aiDescriptionCallsMonthItemLabel' | transloco }} </span>
                                                  <span
                                                  class="text-secondary ms-2">{{currentSubscriptionRule.NumberOfArtistAIDescriptionCalls}}</span>
                                                </div>
                                                <div class="text-small text-muted">{{ 'subscriptionRules.artistAiDescriptionCallsItemHelp' | transloco }}</div>
                                              </div>
                                            </li>
                                            <li>
                                              <div class="d-flex flex-column justify-content-start mt-2">
                                                <div>
                                                  <span class="text-secondary fw-semibold text-uppercase">{{ 'subscriptionRules.artTypesSelectionItemLabel' | transloco }} </span>
                                                  <span class="text-secondary ms-2">{{currentSubscriptionRule.NumberOfArtTypeSelection}}</span>
                                                </div>
                                                <div class="text-small text-muted">{{ 'subscriptionRules.artTypesSelectionItemHelp' | transloco }}</div>
                                              </div>
                                            </li>
                                            <li>
                                              <div class="d-flex flex-column justify-content-start mt-2">
                                                <div>
                                                  <span class="text-secondary fw-semibold text-uppercase">{{ 'subscriptionRules.portfolioCreationItemLabel' | transloco }} </span>
                                                  <span class="text-secondary ms-2">{{currentSubscriptionRule.NumberOfArtistPortfolios}}</span>
                                                </div>
                                                <div class="text-small text-muted">{{ 'subscriptionRules.artistPortfoliosItemHelp' | transloco }}</div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </p-accordionTab>
                                  </p-accordion>
                                }
                              </p-tabPanel>
                            </p-tabView>
                          </div>
                        }

                        <!-- Table Section -->
                        @if (subscriptionRuleSetUsersLoaded) {
                          <div class="table-responsive p-3">
                            <p-table #dt [value]="filteredRuleSetUsers" dataKey="Id" [rowHover]="true"
                              styleClass="p-datatable-gridlines p-datatable-striped"
                              [globalFilterFields]="['Name', 'Email', 'PhoneNumber', 'BusinessName']" selectionMode="single"
                              [paginator]="filteredRuleSetUsers.length > 10" [rows]="10" [reorderableColumns]="true" [resizableColumns]="false">
                              <!-- Table Caption with Search Box -->
                              <ng-template pTemplate="caption">
                                <div class="d-flex justify-content-start align-items-center mb-3">
                                  <div class="d-flex align-items-center flex-grow-1">
                                    <div class="searchbox rounded-3 bg-light d-flex align-items-center position-relative w-100 me-3">
                                      <input type="text" class="form-control form-control-sm border-0 rounded-3 ps-5"
                                        (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'subscriptionRules.searchPlaceholder' | transloco" />
                                      </div>
                                    </div>
                                  </div>
                                </ng-template>
                                <!-- Table Header -->
                                <ng-template pTemplate="header">
                                  <tr>
                                    <th [pSortableColumn]="'Name'" class="text-nowrap">{{ 'subscriptionRules.thName' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon></th>
                                    <th [pSortableColumn]="'BusinessName'" class="text-nowrap">{{ 'subscriptionRules.thBusiness' | transloco }} <p-sortIcon
                                    [field]="'BusinessName'"></p-sortIcon></th>
                                    <th [pSortableColumn]="'PhoneNumber'" class="text-nowrap">{{ 'subscriptionRules.thPhone' | transloco }}<p-sortIcon
                                    [field]="'PhoneNumber'"></p-sortIcon></th>
                                    <th [pSortableColumn]="'CreatedDate'" class="text-nowrap">{{ 'subscriptionRules.thCreatedDate' | transloco }} <p-sortIcon
                                    [field]="'CreatedDate'"></p-sortIcon></th>
                                    <th class="text-nowrap">{{ 'subscriptionRules.thActions' | transloco }}</th>
                                  </tr>
                                </ng-template>
                                <!-- Table Body -->
                                <ng-template pTemplate="body" let-rowData>
                                  <tr>
                                    <td>
                                      <div class="form-group align-items-center">
                                        <img [src]="rowData.ProfileImageUrl?? 'assets/images/No-Image.png'" class="rounded-circle me-1"
                                          style="width: 25px; height: 25px; object-fit: cover;" />
                                          <span class="text-uppercase ms-2">{{rowData.Name}}</span>
                                        </div>
                                      </td>
                                      <td>
                                        @if (rowData.BusinessName) {
                                          <div class="form-group align-items-center">
                                            <img [src]="rowData.BusinessImageUrl?? 'assets/images/No-Image.png'" class="rounded-circle me-1"
                                              style="width: 25px; height: 25px; object-fit: cover;" />
                                              <span class="text-uppercase ms-2">{{rowData.BusinessName}}</span>
                                            </div>
                                          }
                                        </td>
                                        <td>{{rowData.PhoneNumber}}</td>
                                        <td>{{rowData.CreatedDate | date: 'dd/MM/yyyy HH:mm'}}</td>
                                        <td class="text-center">
                                          <button type="button" pButton icon="fa fa-pencil" [label]="'subscriptionRules.changeRuleset' | transloco"
                                            class="p-button-primary p-button-outlined p-button-sm" (click)="onEditUserSubscription(rowData)">
                                          </button>
                                        </td>
                                      </tr>
                                    </ng-template>
                                    <!-- Empty Message -->
                                    <ng-template pTemplate="emptymessage">
                                      <tr>
                                        <td [attr.colspan]="6" class="text-center">
                                          @if (showArtists) {
                                            <div class="text-muted">{{ 'subscriptionRules.noArtistsFound' | transloco }}</div>
                                          }
                                          @if (!showArtists) {
                                            <div class="text-muted">{{ 'subscriptionRules.noGalleriesFound' | transloco }}</div>
                                          }
                                        </td>
                                      </tr>
                                    </ng-template>
                                  </p-table>
                                </div>
                              }
                            </p-dialog>

                            <p-dialog [header]="'subscriptionRules.editUserRuleset' | transloco" [(visible)]="subscriptionRuleSetsDailogVisible" [modal]="true"
                              [style]="{ width: '530px' }" (onHide)="onCloseSubscriptionRuleSetsDialog()">
                              <div class="grid">
                                <div class="col-12 flex flex-column">
                                  <!-- User Information Section -->
                                  @if (selectedUser) {
                                    <div class="d-flex">
                                      <img [src]="selectedUser.ProfileImageUrl ?? 'assets/images/No-Image.png'" class="rounded-circle me-1"
                                        style="width: 50px; height: 50px; object-fit: cover;" />
                                        <div class="d-flex flex-column ms-2">
                                          <div class="text-uppercase">{{selectedUser.Name}}</div>
                                          <div class="text-muted">{{ 'subscriptionRules.businessNameLabel' | transloco }} {{selectedUser.BusinessName ?? 'No business name found'}}</div>
                                        </div>
                                      </div>
                                    }

                                    <hr />

                                    <!-- Warning Text Section -->
                                    <div class="text-muted mb-2">
                                      <strong>{{ 'subscriptionRules.important' | transloco }}</strong> {{ 'subscriptionRules.changeRulesetWarning' | transloco: { name: selectedUser?.Name } }}
                                    </div>

                                    <hr />

                                    <!-- Ruleset Selection Dropdown -->
                                    <div class="form-group">
                                      <label class="form-label" for="subscriptionRuleSetId">{{ 'subscriptionRules.selectRuleSet' | transloco }}</label>
                                      <p-dropdown [options]="subscriptionRuleSetsDropdown" appendTo="body" [filter]="true" filterBy="label"
                                        id="subscriptionRuleSetId" [showClear]="false" [(ngModel)]="subscriptionRuleSetId"
                                        [placeholder]="'subscriptionRules.selectRuleSetPlaceholder' | transloco" [style]="{'width':'100%'}">
                                      </p-dropdown>
                                      <div class="text-muted mt-2">
                                        {{ 'subscriptionRules.selectRuleSetHelp' | transloco }}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <!-- Action Button Section -->
                                <div class="grid mt-4">
                                  <div class="pt-0">
                                    <button type="button" pButton class="p-button-primary p-button-outlined p-button-sm w-100"
                                      [label]="'subscriptionRules.changeSubscriptionRuleset' | transloco" [disabled]="!subscriptionRuleSetId" (click)="assignSubscriptionRuleSet()">
                                    </button>
                                  </div>
                                </div>
                              </p-dialog>